// extracted by mini-css-extract-plugin
export default {"menuItem":"style_menuItem__9Iyxe","borderBottom":"style_borderBottom__a4PWn","assetBundler":"style_assetBundler__wjb0+","noBorder":"style_noBorder__HfzkR","icon":"style_icon__QCW33"};